export default "__VITE_ASSET__CC5yxFWC__"